/**
 * Скачка файла своей ручки через `fetch`, а не голой `<a download>` (разметка
 * 25.09.26 15:55 п.1): архив техкарт CRM собирает секунды, и без лоадера клик
 * выглядит несработавшим. Заодно ошибка ручки видна словами, а не файлом
 * `techcard` с JSON внутри, который браузер молча сохранил бы вместо архива.
 */

import type { ApiErrorItem } from "@/lib/api";

/**
 * Имя файла из `Content-Disposition`: `filename*` (UTF-8, кириллица) сильнее
 * ASCII-запасного `filename` — сервер кладёт оба (`service.disposition`).
 */
export function fileNameOf(header: string | null, fallback: string): string {
  if (!header) return fallback;
  const star = /filename\*\s*=\s*UTF-8''([^;]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1].trim());
    } catch {
      // битое кодирование — берём ASCII-имя ниже
    }
  }
  const plain = /filename\s*=\s*"([^"]*)"/i.exec(header) ?? /filename\s*=\s*([^;]+)/i.exec(header);
  return plain?.[1]?.trim() || fallback;
}

/** Скачивает `href` и отдаёт браузеру как файл; ошибка — `Error` со словами сервера. */
export async function downloadFile(href: string, fallback = "file"): Promise<void> {
  const response = await fetch(href, { credentials: "same-origin" });
  if (!response.ok) {
    let message = `Сервер ответил ${response.status}`;
    try {
      const payload = (await response.json()) as { error?: ApiErrorItem[] };
      message = payload.error?.[0]?.message ?? message;
    } catch {
      // не JSON — остаётся код ответа
    }
    throw new Error(message);
  }
  const blob = await response.blob();
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = fileNameOf(response.headers.get("Content-Disposition"), fallback);
  document.body.append(link);
  link.click();
  link.remove();
  // Отозвать сразу нельзя: часть браузеров начинает запись файла после `click`.
  setTimeout(() => URL.revokeObjectURL(url), 60_000);
}
